<script>
  import { Link } from 'svelte-routing';
</script>

<main class="flex items-center justify-center vh-100 ph4">
  <div class="w-60 flex flex-column items-center">
    
    <button class="bg-dark-green white pv5 ph6 br3 mb4 f2" style="color: #e8d3b7;">
      Coming Very Soon
    </button>

    <div class="w-100 tl pl6">
      <h1 class="f1 fw6 lh-title white" style="color: #e8d3b7;">
        Online workforce <br /> management for <br /> artisanal bakeries and pastry shops
      </h1>
      <p class="white-70 mt3 f4" style="color: #e8d3b7;">
        Artisanal bakeries and pastry shops use NoonDev solutions to :<br />
        <span class="db">- better manage stocks, costs and employee efficiency</span>
        <span class="db">- track ingredients with a proper ordering tool</span>
        <span class="db">- manage their recipes and volume calculation</span>
        <span class="db">- create pdf invoices to send to institutional customers</span>
        <span class="db">- and many other applications to help your teams</span>
      </p>
    </div>

    <div class="mt4">
      <Link 
        to="/signup" 
        class="pv4 ph5 br4 mr3 f3" 
        style="background-color: #e8d3b7; color: black; text-decoration: none;"
      >
        Free trial
      </Link>
    </div>

  </div>
  <div class="w-40 flex justify-center">
    <div class="phone-frame">
      <img src="/images/Home/add.png" alt="Mobile app screenshot" class="responsive-img" />
    </div>
  </div>
</main>

<style>
  main {
    background: linear-gradient(to bottom right, #2c7cc9 49%, #d1e51e);
    min-height: 100vh;
    color: white;
  }
  .white-70 {
    color: rgba(255, 255, 255, 0.7);
  }
  
  .bg-dark-green {
    background-color: #2c7cc9;
  }
  
  .responsive-img {
    max-width: 100%;
    height: auto;
    max-height: 80vh;
    border-radius: 1.5rem;
  }
  
  .br3 {
    border-radius: 4rem;
  }
  
  .br4 {
    border-radius: 4rem;
  }
  
  .phone-frame {
    padding: 0; /* Remove padding to eliminate gap between frame and image */
    border: 1rem solid #464444; /* Adjust border to simulate phone frame color */
    border-radius: 2.75rem; /* Adjust border radius to simulate phone frame corners */
    background-color: white; /* Background color inside the phone frame */
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2); /* Optional: Add shadow for a more realistic effect */
    display: flex; /* To center the image within the frame */
    justify-content: center; /* To center the image horizontally */
    align-items: center; /* To center the image vertically */
  }
  
  .f4 {
    font-size: 1.25rem; /* Adjust the font size for the buttons */
  }
</style>